<template lang="pug">
div
  el-collapse(v-model='abaAtiva')
    el-collapse-item(v-for="pergunta in perguntas", :name="pergunta.numero", :key="pergunta.numero", :title="pergunta.pergunta")
      p {{ pergunta.resposta }}

</template>

<script>
import { mapActions } from 'vuex'
export default {
  data () {
    return {
      abaAtiva: ['colapse'],
      perguntas: []
    }
  },

  methods: {
    ...mapActions({
      getPerguntas: 'perguntaFrequente/byNumero'
    })
  },

  created () {
    this.getPerguntas().then((perguntas) => {
      this.perguntas = perguntas
    })
  }

}
</script>
<style lang="scss">
@import '@/assets/styles/_variables.scss';

p {
  line-height: 1.5;
  font-size: 16px;
}

.el-collapse-item__header{
  @media only screen and (max-width: 1200px) {
    line-height: normal;
    padding: 32px 0px;
  }
}

.el-collapse-item {

  /deep/ .el-collapse-item__header {
    color: $font-color !important;
    cursor: pointer;
    border-bottom: 1px solid #ebeef5;
    font-weight: 500;
    font-size: $font-size-text !important;

    &.is-active {
      border-bottom-color: transparent;
    }
  }

  /deep/ .el-collapse-item__arrow {
    font-weight: 800 !important;
  }

  /deep/ .el-collapse-item__content {
    color: $font-color !important;
    font-size: $font-size-text !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/screens/portal/publico/components/informacao/PerguntasFrequentes.vue